export default [
    {
        path: '/bayi-listesi',
        name: 'bayi-listesi',
        meta: { resource: 'admin' },
        component: () => import('../views/dealer/list') 
    },
    {
        path: '/bayi-tahsilatlari',
        name: 'bayi-tahsilatlari',
        meta: { resource: 'admin' },
        component: () => import('../views/dealer/bayi_tahsilatlari')
    },
    {
        path: '/bayi-bakiye-hareket',
        name: 'bayi-bakiye-hareket',
        meta: { resource: 'admin' },
        component: () => import('../views/dealer/hareketler')
    },
    {
        path: '/bayi-tahsilatlari-personel',
        name: 'bayi-tahsilatlari-personel',
        meta: { resource: 'admin' },
        component: () => import('../views/dealer/personel')
    },
]
  